import { render, staticRenderFns } from "./MatImage.vue?vue&type=template&id=5f3040b5&scoped=true&"
import script from "./MatImage.vue?vue&type=script&lang=ts&"
export * from "./MatImage.vue?vue&type=script&lang=ts&"
import style0 from "./MatImage.vue?vue&type=style&index=0&id=5f3040b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3040b5",
  null
  
)

export default component.exports